import { BreadcrumbsPage, HeaderTitlePage } from '@/components/custom';
import { IHasChildren } from '@/lib/interface';
import { Separator } from '@/components/ui';
import { TBreadcrumbProps } from '@/types';
import { LucideIcon } from 'lucide-react';
import { ReactNode } from 'react';

type TProps = IHasChildren & {
  breadcrumb?: TBreadcrumbProps;
  icon?: LucideIcon;
  header?: {
    description?: ReactNode;
    title?: ReactNode;
  }
};

const LayoutPage = ({ children, header, breadcrumb, ...props }: TProps) => (
  <div className='
    md:container 
    pt-3
    mx-2
    flex flex-col space-y-3 pb-20
    '>
    <div className='flex flex-col space-y-3 relative'>
      {
        breadcrumb &&
        <BreadcrumbsPage {...breadcrumb} />
      }
      {
        header &&
        <>
          <HeaderTitlePage
            description={header.description}
            title={header.title} />
          <Separator className='bg-muted' />
        </>
      }
      {
        props.icon &&
        <props.icon
          size={80}
          className='absolute -top-5 md:top-0 md:bottom-0 right-0 opacity-5' />
      }
    </div>
    {children}
  </div>
);

export default LayoutPage;
